module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mStep"
  }, [_c('mt-steps', {
    attrs: {
      "direction": "horizontal"
    }
  }, [_c('mt-step', {
    attrs: {
      "status": _vm.status1
    }
  }, [_vm._v("信息校验")]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": _vm.status2
    }
  }, [_vm._v("绑定手机")]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": _vm.status3
    }
  }, [_vm._v("设置密码")]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": _vm.status4
    }
  }, [_vm._v("激活完成")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f092aa00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/mStep.vue
// module id = 203
// module chunks = 0